<template>
  <div>
    <b-modal
      ref="modal-Employee"
      centered
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
    >
      <template #modal-header="">
        <h5>FILE OF EMPLOYEES</h5>
        <b-button
          @click="addEmployee()"
          class="btnAdd"
          size="sm"
          variant="dark"
        >
          <!-- <strong>NEW</strong> -->
          New
        </b-button>
      </template>
      <!--       <b-row>
        <b-col cols="2">
          <strong>Category:</strong>
        </b-col>
        <b-col cols="10">
          <b-form-radio-group
            v-model="categorySelected"
            :options="categorias"
            class="mb-3"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </b-col>
      </b-row> -->

      <b-table
        hover
        striped
        select-mode="single"
        small
        sticky-header
        :items="items"
        :fields="fields"
        :busy="isBusy"
        head-variant="dark"
        class="mt-3"
        bordered
        style="max-height: 500px"
        ref="selectableTable"
        selectable
      >
        <template #cell(delete)="row">
          <b-button
            variant="outline-danger"
            @click="promptDelete(row.item, row.index)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>

        <template #cell(edit)="row">
          <b-button @click="editEmployee(row.item)" variant="outline-success">
            <b-icon icon="pencil"></b-icon>
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <div class="w-100">
          <p class="float-left">
            <strong> Count: {{ count }}</strong>
          </p>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            class="float-right"
            size="sm"
            variant="secondary"
            @click="goHome()"
          >
            go Back
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalEditShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Edit Employee</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="name"
              v-model="actualEmployee.nombre"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Address"
            label-for="address"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="actualEmployee.direccion"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Email"
            label-for="email"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="email"
              v-model="actualEmployee.email"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Phone"
            label-for="phone"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="phone"
              v-model="actualEmployee.telefono"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalEditShow = !modalEditShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="modalAddShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Add New Employee</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input id="name" v-model="newEmployee.nombre"></b-form-input>
          </b-form-group>

          <b-form-group
            label="Address"
            label-for="address"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="newEmployee.direccion"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Email"
            label-for="email"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input id="email" v-model="newEmployee.email"></b-form-input>
          </b-form-group>

          <b-form-group
            label="Phone"
            label-for="phone"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="phone"
              v-model="newEmployee.telefono"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalAddShow = !modalAddShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Employees",
  data: function () {
    return {
      url: "https://www.imandrades.com/apiIMA/nomina.php?action=",

      isBusy: false,
      fields: [
        { key: "nombre", label: "Name", class: "text-left" },
        { key: "delete", class: "text-center" },
        { key: "edit", class: "text-center" },
      ],
      modalEditShow: false,
      modalAddShow: false,
      items: [],
      employeees: [],
      actualEmployee: {},
      newEmployee: {},
      count: 0,
      confirmDelete: "",
      currentDivision: "GEORGIA",
    };
  },
  mounted() {
    this.$refs["modal-Employee"].show();
    this.leerEmpleados();
  },
  methods: {
    leerEmpleados: async function () {
      this.isBusy = true;
      try {
        let respuesta = await axios.get(this.url + "getEmpleados");
        this.employees = respuesta.data.empleados;
        this.items = this.employees;
        this.count = this.items.length - 1;
        this.isBusy = false;
      } catch (error) {
        console.log("Error Leyendo Employeees");
      }
    },
    goHome() {
      this.$refs["modal-Employee"].hide();
      this.$router.push("menuDesktop");
    },
    /* onRowSelected() {
      this.selected = items;
      console.log(this.selected);
    }, */
    promptDelete(item, index) {
      console.log("ITEM:", item);
      console.log("INDEX:", index);
      this.confirmDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete Employee '" +
            item.nombre +
            "'",
          {
            title: "Delete Employee",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          this.confirmDelete = value;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editEmployee(item) {
      this.actualEmployee = item;
      this.modalEditShow = true;
    },
    addEmployee() {
      this.newEmployee = {};
      this.modalAddShow = true;
    },
    showMsgSave() {
      this.boxTwo = "";
      this.modalEditShow = false;
      this.modalAddShow = false;
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>


<style scoped>
.btnAdd {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.btnAdd:hover {
  transform: scale(1.2);
}
</style>

